/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search events..." |
*
* @param {Editor_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_search_placeholder = /** @type {((inputs?: Editor_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des evenements...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchereignisse...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca eventi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск событий...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar eventos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索事件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを検索...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज कार्यक्रम...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pesquisar eventos...")
	return /** @type {LocalizedString} */ ("Search events...")
});